import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_VENDOR_PRICING, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_VENDOR_PRICING,
  UPDATE_VENDOR_PRICING,
  DELETE_VENDOR_PRICING
 } from "./actionTypes";
import {
  getVendor_pricingSuccess,
  getVendor_pricingFail,
  addVendor_pricingSuccess,
  addVendor_pricingFail,
  updateVendor_pricingSuccess,
  updateVendor_pricingFail,
  deleteVendor_pricingSuccess,
  deleteVendor_pricingFail,
  // getVendor_pricingProfileSuccess,
  // getVendor_pricingProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getVendor_pricing,
  // getVendor_pricingProfile,
  addNewVendor_pricing,
  updateVendor_pricing,
  deleteVendor_pricing,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchVendor_pricing({payload:{id,offset,page_size}}) {
  try {
    const response = yield call(getVendor_pricing,{id,offset,page_size});
    yield put(getVendor_pricingSuccess(response));

  } catch (error) {
    yield put(getVendor_pricingFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onUpdateVendor_pricing({ payload: { user, history } }) {
  try {
    let response = yield call(updateVendor_pricing, user)
    // if (response.file_src || user.removeImage)
    //   user.image = response.file_src
    // yield put(updateVendor_pricingSuccess(user))
    yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(updateVendor_pricingFail(error))
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onDeleteVendor_pricing({ payload: ceremony }) {
  
  try {
    let response = yield call(deleteVendor_pricing, ceremony);
    yield put(deleteVendor_pricingSuccess(ceremony));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(deleteVendor_pricingFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onAddNewVendor_pricing({ payload: {user, history } }) {
  try {
    const response =  yield call(addNewVendor_pricing, user);
    yield put(addVendor_pricingSuccess(response.data));
    yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(addVendor_pricingFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}


// function* fetchVendor_catProfile() {
//   try {
//     const response = yield call(getVendor_catProfile);
//     yield put(getVendor_catProfileSuccess(response));
//   } catch (error) {
//     yield put(getVendor_catProfileFail(error));
//   }
// }

function* ceremonysSaga() {
  yield takeEvery(GET_VENDOR_PRICING, fetchVendor_pricing);
  yield takeEvery(ADD_NEW_VENDOR_PRICING, onAddNewVendor_pricing);
  yield takeEvery(UPDATE_VENDOR_PRICING, onUpdateVendor_pricing);
  yield takeEvery(DELETE_VENDOR_PRICING, onDeleteVendor_pricing);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchVendor_catProfile);
}

export default ceremonysSaga;
